import {WindowProxyImpl} from './services/WindowProxyImpl';
import {IApplication} from './IApplication';
import {ILoadingScreen} from './services/LoadingScreen';
import {IActionFactory} from './actions/ActionFactory';
import { IToastMessage } from 'services/IToastMessage';

export class IntegrationApp implements IApplication {
    constructor(
        private windowObj: Window,
        private loadingScreen: ILoadingScreen,
        private toastMessage: IToastMessage,
        private actionFactory: IActionFactory,
    ) {
    }

    public run(): void {
        const emptyStrFunc = () => '';
        // Patch game integration functions that doesn't exist in E4K
        this.windowObj.ggsGetQueryParameters = emptyStrFunc;

        this.windowObj.ggsGetReferrer = emptyStrFunc;

        // currently we need this to show rewards
        this.windowObj.forceRefreshDialog = true;

        this.windowObj.showLoadingScreen = () => this.loadingScreen.show();

        this.windowObj.hideLoadingScreen = () => this.loadingScreen.hide();

        this.windowObj.toastMessage = this.toastMessage.toast.bind(this.toastMessage);

        this.windowObj.addEventListener('message', ({data, source, origin}) => {
            if (!data) {
                return;
            }

            const action = this.actionFactory.create(data.eventName, {
                windowProxy: new WindowProxyImpl(source, origin),
                searchParams: (new URL(document.location.toString())).searchParams
            });
            action.execute(data);
        })
    }
}

